import React from 'react';
import styled from 'styled-components';
import Link from '@mui/material/Link';
import { string } from 'prop-types';

const WrapperLink = styled(Link)`
  font-size: ${(props) =>
    props.disabled === true
      ? props.disabledFontSize + 'px'
      : props.size + 'px'} !important;
  font-family: ${(props) =>
    props.disabled === true
      ? props.disabledFontFamily
      : props.fontFamily} !important;
  font-weight: ${(props) => props.fontWeight} !important;
  color: ${(props) =>
    props.disabled === true ? '#998A7B' : '#242E39'} !important;
  margin: ${(props) => props.margin + 'px'} !important;
  padding: ${(props) => props.padding + 'px'} !important;
  text-decoration: ${(props) => props.TextDecoration} !important;
  cursor: ${(props) => props.cursor} !important;
  pointer-events: ${(props) => (props.disabled === true ? 'none' : '')};

  ${(props) =>
    props.lineHeight &&
    `
        line-height:  ${props.lineHeight + 'px'} !important;
    `}
  ${(props) =>
    props.borderBottom &&
    `
        border-bottom:  1px solid #FFFFFF;
    `};
`;

function MuiLink(props) {
  return <WrapperLink {...props}>{props.children}</WrapperLink>;
}

MuiLink.propTypes = {
  color: string.isRequired,
};

MuiLink.defaultProps = {
  size: 14,
  disabledFontSize: 14,
  fontFamily: ' outfit_semiBold',
  disabledFontFamily: 'outfit_regular',
  fontWeight: 400,
  textColor: '#0054F6',
  TextDecoration: 'none',
};

export default MuiLink;
